import type { BoardCard } from '../types';
import type { boardApi, BoardHelper, BoardUpdateBody } from '../api/board';

// A blocked update is one atomic block request, never a status write followed
// by dependency creation. Keep ordinary progress updates on their existing API.
export function saveBoardProgress(api: Pick<typeof boardApi, 'block' | 'teamBlock' | 'addUpdate'>, id: number, update: BoardUpdateBody, team: boolean, dependency: { helpers: BoardHelper[]; external?: { name: string } }) {
  if (update.status !== 'blocked') return api.addUpdate(id, update, team);
  const { status: _status, ...note } = update;
  return (team ? api.teamBlock : api.block)(id, { reason: update.text, ...dependency, update: note });
}

export function unresolvedBoardHelpers(card: BoardCard) {
  return (card.blockers ?? []).filter((helper) => helper.col !== 'done');
}

export function canReturnBoardHelper(card: BoardCard) {
  return Boolean(card.blocking && !card.handed_back_at && card.col !== 'done' && !card.blocked_external_name && !unresolvedBoardHelpers(card).length);
}

export function selectsRequester(card: BoardCard, helpers: { user_id: number | null }[]) {
  return Boolean(card.blocking && helpers.some((helper) => helper.user_id === card.blocking?.user_id));
}
